import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AccountService } from "src/app/dashboard/services/account.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-internal-transfer",
  templateUrl: "./internal-transfer.component.html",
  styleUrls: ["./internal-transfer.component.css"]
})
export class InternalTransferComponent implements OnInit {
  internalTransferForm: FormGroup;
  tradeAccounts: { login: number; type: string } = null;
  isInternalTransferLoading: boolean = false;

  constructor(private account: AccountService) {}
  ngOnInit() {
    this.internalTransferForm = new FormGroup({
      fromLogin: new FormControl(null, [Validators.required]),
      toLogin: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required, Validators.min(1)])
    });

    this.getAccounts();
  }

  getAccounts() {
    this.account.getLiveAccountsList().subscribe(response => {
      if (response.request_status) {
        this.tradeAccounts = response.data;
      }
    });
  }

  internalTransfer() {
    this.isInternalTransferLoading = true;
    let formData: { from_login: number; to_login: number; amount: number } = {
      from_login: this.internalTransferForm.value.fromLogin.login,
      to_login: this.internalTransferForm.value.toLogin.login,
      amount: this.internalTransferForm.value.amount
    };

    this.account.internalTransfer(formData).subscribe(
      response => {
        this.isInternalTransferLoading = false;
        if (response.request_status) {
          Swal.fire("Internal Transfer Completed", "", "success");
          this.internalTransferForm.reset();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      error => {
        this.isInternalTransferLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }
}
